<template>
    <div class="d-flex mb-3 align-center">
        <p v-if="label" class="text-small font-weight-medium text-grey-darken-2 me-3 user-select-none">{{ label }}</p>
        <v-text-field
            dir="ltr"
            :rules="$validation([required ? 'required' : false, 'max:59'].filter(Boolean))"
            hide-details
            variant="underlined"
            placeholder="دقیقه"
            style="width:50px"
            ref="min"
            :model-value="localValue.min"
            @update:modelValue="(value) => {localValue = {hour: localValue.hour, min: value}}"
            @paste.prevent=""
            class="pa-1 flex-shrink-0 flex-grow-0"
        ></v-text-field>
        <h4 class="font-weight-bold text-grey-darken-2 mb-0 mt-2 user-select-none">:</h4>
        <v-text-field
            :rules="$validation([required ? 'required' : false, 'max:999'].filter(Boolean))"
            hide-details
            variant="underlined"
            placeholder="ساعت"
            style="width:55px"
            ref="hour"
            :model-value="localValue.hour"
            @update:modelValue="(value) => {localValue = {hour: value, min: localValue.min}}"
            @paste.prevent=""
            class="pa-1 flex-shrink-0 flex-grow-0"
        ></v-text-field>
        <div v-if="clearable && (localValue.hour || localValue.min)">
            <v-icon @click="localValue = {hour: null, min: null}" class="cursor-pointer " color="grey" size="20">clear</v-icon>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        modelValue: {
            required: true,
        },
        label: {
            type: String
        },
        required: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        localValue: {
            get: function () {
                let value = this.modelValue?.split(':') ?? [null, null];
                return {
                    hour: value[0],
                    min: value[1],
                }
            },
            set: function (value) {
                this.$emit('update:modelValue', Object.values(value).join(':'));
            }
        },
    },
}
</script>
